import { driveDigitalHumanByText } from '@/pages/DigitalHuman/util/tts-manage';
import { Store, useStore } from './index';
import { LandmarkPoetryPlaceDetailType, PageMode } from './types';
import { useAutoSilent } from './useAutoSilent';


interface ControlData {
  mode: PageMode;
  location?: string;
  location_id?: string;
  event?: string;
  event_id?: string;
  start_time?: string;
  end_time?: string;
  start_year?: string;
  end_year?: string;
  card?: string;
  person?: string;
  theme?: string;
  tour?: string;
  tour_id?: string;
}

const useControl = () => {
  const { setMode, setLandmarkPoetryMode, setEventCardMode, setHomeMode, setRouteTimeLineDetailId, setRouteDetailMode } = useStore();
  const { reset } = useAutoSilent();

  const set = (data: ControlData) => {
    reset(); // 调用 reset 方法重置时间
    // console.log('data',data);

    if (data.mode === PageMode.HOME) {
      // 模式控制
      if(data?.location&&!data?.location_id){
        driveDigitalHumanByText(`未找到${data.location}，请查看其他地点`);
        return;
      }

      setHomeMode(data.location_id);

      // 语音控制
      // if (data.location_id) {
      //   driveDigitalHumanByText(`好的，已为您介绍${data.location}，请看详情页。`);
      // } else {
      //   driveDigitalHumanByText('“文学西湖”从百亿+文学数据中挖掘出10,128首与杭州西湖直接相关的诗词文章，涵盖唐宋至近现代1000+位文学家，涉及200+地标，构建全球最完整的西湖文学动态演绎长卷；以一次穿越时空的“心与物游”、古今对话，激活“诗性西湖”的当代生命力。 ');
      // }
    } else if (data.mode === PageMode.EVENT) {

      if(data?.event&&!data?.event_id){
        driveDigitalHumanByText(`未找到${data.event}，请查看其他事件`);
        return;
      }

      // if(data?.start_time&&!data?.start_year&&data?.end_time&&!data?.end_year){
      //   driveDigitalHumanByText(`未找到${data.start_time}到${data.end_time}西湖发生的大事件，请查看其他时间`);
      //   return;
      // }

      // if(data?.start_time&&!data?.start_year){
      //   driveDigitalHumanByText(`未找到${data.start_time}西湖发生的大事件，请查看其他时间`);
      //   return;
      // }
      // if(data?.end_time&&!data?.end_year){
      //   driveDigitalHumanByText(`未找到${data.end_time}西湖发生的大事件，请查看其他时间`);
      //   return;
      // }
      const missingYears = [];
      if (data?.start_time && !data?.start_year) missingYears.push(data.start_time);
      if (data?.end_time && !data?.end_year) missingYears.push(data.end_time);

      if (missingYears.length > 0) {
        // 这里用Set来做一下排重
        const timeRange = Array.from(new Set(missingYears)).join('到');
        driveDigitalHumanByText(`未找到${timeRange}西湖发生的文学大事件，请查看其他时间`);
        return;
      }

      // 模式控制
      if((data?.start_year||data?.start_time)||(data?.end_year||data?.end_time)){
        const time: Store['eventDynastyRange'] = [data.start_time||null, data.end_time||null,data.start_year||null,data.end_year||null];
        setEventCardMode(data.event_id||null, time);
      }else {
        setEventCardMode(data.event_id||null, null);
      }
    

      // 语音控制
      // if (data.event) {
      //   driveDigitalHumanByText(`我们现在看到的是${data.event}事件`);
      // } else if (data.start_time && data.end_time) {
      //   if(data.start_time === data.end_time){
      //     driveDigitalHumanByText(`我们现在看到的是${data.start_time}西湖发生的大事件`);
      //   }else {
      //     driveDigitalHumanByText(`我们现在看到的是${data.start_time}到${data.end_time}西湖发生的大事件`);
      //   }
      // } else {
      //   driveDigitalHumanByText('“文学西湖”从百亿+文学数据中精选100+最具代表的西湖文学大事件，以此碎片映照出流动的西湖千年文脉。');
      // }
    } else if (data.mode === PageMode.LANDMARK_POETRY) {

      if(data?.location&&!data?.location_id){
        driveDigitalHumanByText(`未找到${data.location}，请查看其他地点`);
        return;
      }

      // 模式控制
      setLandmarkPoetryMode(data.location_id, data.card as LandmarkPoetryPlaceDetailType, data.person);

      // 语音控制
      // if (data.location && data.card) {
      //   if (data.card === LandmarkPoetryPlaceDetailType.POEM) {
      //     driveDigitalHumanByText(`我们现在看到的是诗人在${data.location}写的诗词`);
      //   } else if (data.card === LandmarkPoetryPlaceDetailType.POET) {
      //     driveDigitalHumanByText(`我们现在看到的是诗人在${data.location}写的诗词篇数`);
      //   }else{
      //     driveDigitalHumanByText('西湖的每一个景点，都留下了数不胜数的名篇佳作。从百亿+文学数据中挖掘出10,128首与杭州西湖直接相关的诗词文章，涵盖唐宋至近现代400位作家，涉及200+地标。此处精选100个地标，以每个地点的文人及作品的数据洞见，勾勒出文学西湖的样貌。');
      //   }
      // } else {
      //   driveDigitalHumanByText('西湖的每一个景点，都留下了数不胜数的名篇佳作。从百亿+文学数据中挖掘出10,128首与杭州西湖直接相关的诗词文章，涵盖唐宋至近现代400位作家，涉及200+地标。此处精选100个地标，以每个地点的文人及作品的数据洞见，勾勒出文学西湖的样貌。');
      // }
    } else if (data.mode === PageMode.ROUTE_CHARACTER_LIST) {
      // 模式控制
      setMode(PageMode.ROUTE_CHARACTER_LIST);

      // 语音控制
      // driveDigitalHumanByText('这18位西湖人物从“时间脉络、精神光谱、地标互文”三个维度勾勒西湖千年文脉。');
    } else if (data.mode === PageMode.ROUTE_THEME_LIST) {
      // 模式控制
      setMode(PageMode.ROUTE_THEME_LIST);

      // 语音控制
      // driveDigitalHumanByText(`一湖碧水，多重境界。西湖主题万千，我们先看六种：从“语文课本”初识“淡妆浓抹总相宜”的晴雨湖山；在四大名著《水浒传》找到隐藏的西湖风景；探寻西湖边俞樾、马一浮、李叔同等文学大家的名人故居；领略“天下第一名社”百年西泠；在岳飞庙和于谦祠，感受英雄之气的生生不息。`);
    } else if (data.mode === PageMode.ROUTE_CHARACTER_TRACK) {
      if (data.tour_id) {
        if (data.card === '详情') {
          // 模式控制
          setRouteTimeLineDetailId(data.tour_id);

          // 语音控制
          // driveDigitalHumanByText(`我们现在看到的是${data.person || ''}文学路线详情`);
        } else {
          // 模式控制
          setRouteDetailMode(data.tour_id);

          // 语音控制
          // driveDigitalHumanByText(`我们现在看到的是${data.person || ''}文学路线`);
        }
      } else {
        // 模式控制
        setMode(PageMode.ROUTE_CHARACTER_TRACK);

        // 语音控制
        // driveDigitalHumanByText('千年风月，一湖诗画。“文学西湖”从1000+文学名人中，精选了18位西湖人物，他们从“时间脉络、精神光谱、地标互文”三个维度勾勒西湖千年文脉。');
      }
    } else if (data.mode === PageMode.ROUTE_THEME_TRACK) {

      if(data?.tour&&!data?.tour_id){
        driveDigitalHumanByText(`未找到${data.tour}，请查看其他线路`);
        return;
      }

      if (data.tour_id) {
        if (data.card === '详情'){
          // 模式控制
          setRouteTimeLineDetailId(data.tour_id);

          // 语音控制
          // driveDigitalHumanByText(`我们现在看到的是${data.theme || ''}主题路线详情`);
        }else {
           // 模式控制
           setRouteDetailMode(data.tour_id);

           // 语音控制
          //  driveDigitalHumanByText(`我们现在看到的是${data.theme || ''}主题路线`);
        }
        
      }else {
        // TODO: 主题游线轨迹暂不支持查看所有
        // 模式控制
        // setMode(PageMode.ROUTE_THEME_TRACK);

        // // 语音控制
        // driveDigitalHumanByText('挑选你想看主题的文学路线吧');
      }
    }else if(data.mode === PageMode.SILENT){
      // 模式控制
      setMode(PageMode.SILENT);
    } else {
      console.info('unknown mode', data.mode);
    }
  };

  return {
    set,
  };
};

export default useControl;
